/**
 * Enum that describes the message level
 */
export enum MsgLevel {
    info = 'info', 
    warning = 'warning', 
    error = 'error'
}